import { render, staticRenderFns } from "./IndividuelAdmin.vue?vue&type=template&id=53490c4c&scoped=true&"
import script from "./IndividuelAdmin.vue?vue&type=script&lang=js&"
export * from "./IndividuelAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53490c4c",
  null
  
)

export default component.exports